import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, mergeMap, catchError } from 'rxjs/operators';

import { ArcGisToken, SetArcGisToken } from 'dnv-lib';

import {
  State, getApplicationState, ArcGisTokenAboutToExpire,
  RenewArcGisTokenSuccess, RenewArcGisTokenError
} from 'src/app/state-management';
import { ArcGisService } from 'src/app/services';

@Injectable()
export class ArcgisInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<State>,
    private arcGisService: ArcGisService
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    if (req.url.indexOf('rest/services') > 0 || req.url.indexOf('rest/directories') > 0) { // server/rest/services
      return this.store.select(getApplicationState).pipe(
        first(),
        mergeMap(applicationState => {

          if (ArcGisTokenAboutToExpire(applicationState.arcGisToken)) {

            // Similar to @Effect() renewArcGisTokenEffect$
            return this.arcGisService.RenewArcGisToken().pipe(
              mergeMap((data: ArcGisToken): Observable<HttpEvent<any>> => {
                this.store.dispatch(new RenewArcGisTokenSuccess({
                  delayedActions: [],
                  success: data
                }));
                this.store.dispatch(new SetArcGisToken(data));
                return next.handle(req.clone({ url: this.appendToken(req.url, data.token) })); // Use the new token immediately
              }),
              catchError((error: HttpErrorResponse) => {
                this.store.dispatch(new RenewArcGisTokenError({
                  delayedActions: [],
                  error
                }));
                return next.handle(req.clone({ url: this.appendToken(req.url, applicationState.arcGisToken.token) }));
              })
            );

          }
          else {
            return next.handle(req.clone({ url: this.appendToken(req.url, applicationState.arcGisToken.token) }));
          }
        }),
      );
    } else {
      return next.handle(req);
    }
  }

  appendToken(url: string, token: string): string {
    if (url.indexOf('?') >= 0) {
      return url + '&token=' + token;
    } else {
      return url + '?token=' + token;
    }
  }
}
